import React, { useState, useEffect, useRef } from 'react';

// Reusable click-to-toggle tooltip — mobile friendly, one open at a time.
// Usage: <Tooltip text="Your explanation here" />

let closeCurrentTooltip = null; // module-level ref so only one is open at a time

export default function Tooltip({ text }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const toggle = (e) => {
    e.stopPropagation();
    if (!open) {
      // Close whatever's currently open
      if (closeCurrentTooltip && closeCurrentTooltip !== setOpen) {
        closeCurrentTooltip(false);
      }
      closeCurrentTooltip = setOpen;
    } else {
      closeCurrentTooltip = null;
    }
    setOpen(v => !v);
  };

  useEffect(() => {
    if (!open) return;
    const handleOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        if (closeCurrentTooltip === setOpen) closeCurrentTooltip = null;
      }
    };
    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('touchstart', handleOutside);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('touchstart', handleOutside);
    };
  }, [open]);

  return (
    <span ref={ref} className="relative inline-flex items-center ml-1.5 flex-shrink-0">
      <button
        type="button"
        onClick={toggle}
        className="w-4 h-4 rounded-full bg-slate-600 hover:bg-slate-500 text-slate-300 text-[10px] font-bold flex items-center justify-center transition-colors leading-none select-none"
        aria-label="More info"
      >
        ?
      </button>
      {open && (
        <div className="absolute left-0 top-6 z-50 w-64 bg-slate-700 border border-slate-600 rounded-xl p-3 shadow-xl text-xs text-slate-300 leading-relaxed"
          style={{ minWidth: 220, maxWidth: 260 }}>
          {text}
        </div>
      )}
    </span>
  );
}
